import { React, useEffect } from "react";
import CardLayout from "../../../components/ReusableComponents/CardLayout";
import DoughnutChart from "../../../components/ReusableComponents/DoughnutChart";
import { ChartCardContent } from "../../dashboard/dashboard.styled";
import { toast } from "react-toastify";
import ChartlabelALT from "../../../components/ReusableComponents/ChartlabelALT";
import { CustomDoughnutOptions } from "../../../Constants";
import { useDispatch, useSelector } from "react-redux";
import { updateUserCharts } from "../UserSlice";
import { fetchChartData } from "../utils";

function UserCharts() {
	useEffect(() => {
		getChartData();
	}, []);

	const chartInfo = useSelector((state) => state.user.chart.info);
	const totalValue = useSelector((state) => state.user.chart.totalValue);

	const dispatch = useDispatch();

	const chart1Data = {
		labels: ["logistics", "account manager", "super-admin", "risk & compliance", "catalogue", "finance"],
		datasets: [
			{
				label: "users",
				data: [
					chartInfo.logistics,
					chartInfo.accountManager,
					chartInfo.admin,
					chartInfo.riskComp,
					chartInfo.catalogue,
					chartInfo.finance,
				],
				backgroundColor: [
					"#fcd9d9",
					"#e2b3ff",
					"rgba(0, 174, 38, 0.2)",
					"#f9ffae",
					" rgba(255, 164, 99, 0.8)",
					"#ccd5dd",
				],
			},
		],
		totalValue: totalValue.chart1,
	};

	const getChartData = async () => {
		try {
			// eslint-disable-next-line no-unused-vars
			const chartInfo = await fetchChartData();
			if (chartInfo?.result) {
				let result = {
					info: {
						logistics: chartInfo.result?.logistics,
						accountManager: chartInfo.result?.accountManager,
						riskComp: chartInfo.result?.riskComp,
						catalogue: chartInfo.result?.catalogue,
						finance: chartInfo.result?.finance,
						admin: chartInfo.result?.admin,
					},
					totalValue: {
						chart1:
							chartInfo.result?.logistics +
							chartInfo.result?.accountManager +
							chartInfo.result?.admin +
							chartInfo.result?.riskComp +
							chartInfo.result?.catalogue +
							chartInfo.result?.finance,
						// chart2: chartInfo.result?.customersPerTime + chartInfo.result?.totalCustomers,
					},
				};
				//update state here
				dispatch(updateUserCharts(result));
			}
		} catch (error) {
			console.log(error);
			toast.error("unable to fetch charts data");
		}
	};

	return (
		<div style={{ width: "60%", marginTop: "1rem" }}>
			<CardLayout type='Users'>
				<ChartCardContent>
					<DoughnutChart totalAmount={totalValue.chart1} data={chart1Data} options={CustomDoughnutOptions} />
					<ChartlabelALT
						firstColorId={"#fcd9d9"}
						firstCaption={"Logistics"}
						firstAmount={chartInfo?.logistics}
						secondColorId={"#f9ffae"}
						secondCaption={"Risk & Compliance"}
						secondAmount={chartInfo?.riskComp}
						thirdColorId={"rgba(255, 164, 99, 0.8)"}
						thirdCaption={"AF Account manager"}
						thirdAmount={chartInfo?.accountManager}
						fourthColorId={"rgba(0, 174, 38, 0.2)"}
						fourthCaption={"Admin"}
						fourthAmount={chartInfo?.admin}
						fifthColorId={" rgba(255, 164, 99, 0.8)"}
						fifthCaption={"Catalogue"}
						fifthAmount={chartInfo?.catalogue}
						sixthColorId={"#ccd5dd"}
						sixthCaption={"Finance"}
						sixthAmount={chartInfo?.finance}
						totalAmount={totalValue.chart1}
						customLabel={"user(s)"}
					/>
				</ChartCardContent>
			</CardLayout>
		</div>
	);
}

export default UserCharts;
